import posthog from 'posthog-js'

let enabled = false

function stripEnvQuotes (value) {
  if (value === undefined || value === null) return ''
  return String(value).replace(/^['"]|['"]$/g, '').trim()
}

/**
 * Initialize PostHog when VUE_APP_POSTHOG_KEY is set. No-op otherwise.
 * Autocapture and automatic pageviews are disabled; use track-events.js for explicit events.
 */
export function initPosthog () {
  const key = stripEnvQuotes(process.env.VUE_APP_POSTHOG_KEY)
  if (!key) return

  const host = stripEnvQuotes(process.env.VUE_APP_POSTHOG_HOST) || 'https://us.i.posthog.com'

  posthog.init(key, {
    api_host: host,
    autocapture: false,
    persistence: 'localStorage+cookie',
    defaults: '2026-01-30'
  })
  enabled = true
}

export function capturePosthog (eventName, properties) {
  if (!enabled) return
  try {
    posthog.capture(eventName, properties)
  } catch (e) {
    console.warn('PostHog capture failed:', e)
  }
}

export function identifyPosthogDistinctId (userId) {
  if (!enabled || !userId) return
  try {
    posthog.identify(String(userId))
  } catch (e) {
    console.warn('PostHog identify failed:', e)
  }
}

export function identifyPosthogWithPerson (userId, personProps) {
  if (!enabled || !userId) return
  try {
    posthog.identify(String(userId), personProps || {})
  } catch (e) {
    console.warn('PostHog identify failed:', e)
  }
}



// WEBPACK FOOTER //
// ./src/lib/posthog-client.js